import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IMessage_Status {
  id: number;
  status_name: string;
  to_pay?: boolean;
}

interface IMessage_StatusData {
  list?: Array<IMessage_Status>;
  pageNo: number;
  pageSize: number;
  searchKey?: string;
  totalCount?: number;
  message?: { text: string; type: string };
}

const initialState: IMessage_StatusData = {
  pageNo: 1,
  pageSize: 20,
  searchKey: "",
  list: [],
  totalCount: 0,
  message: { text: "", type: "success" },
};

const message_statusSlice = createSlice({
  name: "message_status",
  initialState,
  reducers: {
    setMessage_StatusList: (
      state,
      _action: PayloadAction<IMessage_StatusData>
    ) => {
      state.list = _action.payload.list;
      state.pageNo = _action.payload.pageNo;
      state.pageSize = _action.payload.pageSize;
      state.totalCount = _action.payload.totalCount;
    },
    resetMessage_StatusToInit: (state) => {
      state = initialState;
    },
    setMessage_StatusMessage: (
      state,
      _action: PayloadAction<{ text: string; type: string }>
    ) => {
      state.message = _action.payload;
    },
  },
});

export const {
  setMessage_StatusList,
  resetMessage_StatusToInit,
  setMessage_StatusMessage,
} = message_statusSlice.actions;

export default message_statusSlice.reducer;
